import  gql  from 'graphql-tag'

export const SHARE_WORKSHEET_FTP = gql`mutation shareWorksheetByFtp($input: ShareWorksheetBySFTPMutationInput!){
    shareWorksheetByFtp(input: $input){
        errors{
            field
            messages
        }
    }
}`;